var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "card-box" },
      [
        _c(
          "el-card",
          {
            staticClass: "box-card",
            attrs: { "body-style": { padding: "20px 20px 0" } },
          },
          [
            _c(
              "div",
              { staticClass: "setting-container" },
              [
                _c(
                  "el-row",
                  [
                    _c("el-col", _vm._b({}, "el-col", _vm.grid1, false), [
                      _vm._v(" "),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      _vm._b({}, "el-col", _vm.grid2, false),
                      [
                        _c(
                          "el-form",
                          {
                            ref: "elForm",
                            attrs: {
                              model: _vm.formData,
                              rules: _vm.rules,
                              "label-width": "200px",
                              size: "medium",
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "card-list" },
                              [
                                _c("div", { staticClass: "head" }, [
                                  _c("span", { staticClass: "line" }, [
                                    _vm._v("|"),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "title" }, [
                                    _vm._v("客户跟进规则"),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "客户跟进提醒：",
                                      prop: "follow_up_switch",
                                    },
                                  },
                                  [
                                    _c("el-switch", {
                                      attrs: {
                                        "active-value": 1,
                                        "inactive-value": 0,
                                        "active-color": "#1890ff",
                                        "active-text": "开启",
                                        "inactive-color": "#909399",
                                        "inactive-text": "关闭",
                                      },
                                      model: {
                                        value: _vm.formData.follow_up_switch,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "follow_up_switch",
                                            $$v
                                          )
                                        },
                                        expression: "formData.follow_up_switch",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.formData.follow_up_switch
                                  ? [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "客户状态：",
                                            prop: "follow_up_status",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-checkbox-group",
                                            {
                                              on: {
                                                change: _vm.handleCheckChange,
                                              },
                                              model: {
                                                value:
                                                  _vm.formData.follow_up_status,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.formData,
                                                    "follow_up_status",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "formData.follow_up_status",
                                              },
                                            },
                                            [
                                              _c(
                                                "el-checkbox",
                                                { attrs: { label: "2" } },
                                                [_vm._v("未成交")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "el-checkbox",
                                                { attrs: { label: "1" } },
                                                [_vm._v("已成交")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "info" },
                                                [
                                                  _vm._v(
                                                    "用于设置需要跟进提醒的客户状态"
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.getVal(2)
                                        ? _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "未成交提醒：",
                                                prop: "follow_up_unsettled",
                                              },
                                            },
                                            [
                                              _c(
                                                "el-input",
                                                {
                                                  staticStyle: {
                                                    width: "350px",
                                                  },
                                                  attrs: {
                                                    clearable: "",
                                                    placeholder: "请输入正整数",
                                                    "show-word-limit": "",
                                                    size: "small",
                                                    type: "number",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.formData
                                                        .follow_up_unsettled,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.formData,
                                                        "follow_up_unsettled",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formData.follow_up_unsettled",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "template",
                                                    { slot: "suffix" },
                                                    [_vm._v("天")]
                                                  ),
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "info" },
                                                [
                                                  _vm._v(
                                                    "用于设置暂未成交状态的客户多少天需要跟进一次"
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.getVal(1)
                                        ? _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "已成交提醒：",
                                                prop: "follow_up_traded",
                                              },
                                            },
                                            [
                                              _c(
                                                "el-input",
                                                {
                                                  staticStyle: {
                                                    width: "350px",
                                                  },
                                                  attrs: {
                                                    clearable: "",
                                                    placeholder: "请输入正整数",
                                                    "show-word-limit": "",
                                                    size: "small",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.formData
                                                        .follow_up_traded,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.formData,
                                                        "follow_up_traded",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formData.follow_up_traded",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "template",
                                                    { slot: "suffix" },
                                                    [_vm._v("天")]
                                                  ),
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "info" },
                                                [
                                                  _vm._v(
                                                    "用于设置已成交状态的客户多少天需要跟进一次"
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "small",
                                          type: "primary",
                                        },
                                        on: { click: _vm.saveEvt },
                                      },
                                      [_vm._v("保存")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              2
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }